import React, {FC} from 'react';
import {Badge} from './GenericBadges';

interface Props {
  dataTestId: string;
  text: string;
  untranslatedLabel?: string;
}

export const UpcyclingBadge: FC<Props> = ({
  dataTestId,
  text,
  untranslatedLabel,
}) => {
  return (
    <Badge
      text={text}
      dataTestId={dataTestId}
      emoji="♻️"
      disableRoundedCorners
      untranslatedLabel={untranslatedLabel}
    />
  );
};
